import { render, staticRenderFns } from "./BaseTinyInput.vue?vue&type=template&id=1f0fce0d&scoped=true&"
import script from "./BaseTinyInput.vue?vue&type=script&lang=js&"
export * from "./BaseTinyInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseTinyInput.vue?vue&type=style&index=0&id=1f0fce0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0fce0d",
  null
  
)

export default component.exports